import { ChevronDown } from "lucide-react";

type ExtraCostField =
  "shippingCost" | "insuranceCost" | "installationCost" | "otherCost";

export type OfferExtraCostValues = Record<ExtraCostField, string> & {
  otherCostDescription: string;
};

const extraCostFields: Array<[ExtraCostField, string]> = [
  ["shippingCost", "Nakliye maliyeti"],
  ["insuranceCost", "Sigorta maliyeti"],
  ["installationCost", "Kurulum maliyeti"],
  ["otherCost", "Diğer ek maliyet"],
];

export function OfferExtraCostsFields({
  open,
  values,
  onToggle,
  onChange,
  onDescriptionChange,
}: {
  open: boolean;
  values: OfferExtraCostValues;
  onToggle: () => void;
  onChange: (field: ExtraCostField, value: string) => void;
  onDescriptionChange: (value: string) => void;
}) {
  return (
    <>
      <button
        type="button"
        className="form-disclosure form-field-wide"
        aria-expanded={open}
        onClick={onToggle}
      >
        <span>
          <strong>Ek maliyetler</strong>
          <small>Nakliye, sigorta veya kurulum varsa ekleyin.</small>
        </span>
        <ChevronDown size={16} />
      </button>
      {open ? (
        <>
          {extraCostFields.map(([field, label]) => (
            <label key={field}>
              {label}
              <input
                type="number"
                min="0"
                step="0.01"
                value={values[field]}
                onChange={(event) => onChange(field, event.target.value)}
              />
            </label>
          ))}
          <label className="form-field-wide">
            Diğer maliyet açıklaması
            <input
              value={values.otherCostDescription}
              onChange={(event) => onDescriptionChange(event.target.value)}
            />
          </label>
        </>
      ) : null}
    </>
  );
}
